import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import CourseComponent from './js/course.component';
import CourseToggleView from './js/course-toggle-view';
import CourseTile from './js/course-tile';

ComponentsFactory.getInstance().define('course', CourseComponent);

export * from './js/enums';
export {
    CourseToggleView,
    CourseTile,
};
